import { Box, FormLabel, FormLabelProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)(() => ({
  width: '100%',

  '& .MuiFormControl-root': {
    width: '100%',
  },
}));

export const StyledFormLabel = styled(FormLabel)<FormLabelProps>(() => ({
  width: '100%',
  marginBottom: '8px',
}));
